export const SET_ADMIN_TAB_REQUESTED = 'SET_ADMIN_TAB_REQUESTED';
export const SET_ADMIN_TAB_COMPLETED = 'SET_ADMIN_TAB_COMPLETED';

export const RESET_ADMIN_TAB_REQUESTED = 'RESET_ADMIN_TAB_REQUESTED';
export const RESET_ADMIN_TAB_COMPLETED = 'RESET_ADMIN_TAB_COMPLETED';
